


// Function to get shape based on type
function getShapeByType(type, dataType) {
  if (dataType === "Different") return "pentagon";
  if (!type) return "rectangle";

  const lowerType = type.toLowerCase();

  const shapeMap = {
    cnv: "triangle",
    mrna: "circle",
    protein: "rectangle",
    mutation: "diamond",
    fusion: "hexagon",
    methylation: "octagon",
    molecular: "pentagon",
  };

  // Find the first matching key inside the string
  for (const key in shapeMap) {
    if (lowerType.includes(key)) {
      return shapeMap[key];
    }
  }

  return "rectangle"; // fallback
}


function getFontColorByBackground(bgColor) {
  if (typeof bgColor !== "string" || !bgColor.startsWith("#") || bgColor.length !== 7) {
    return "#fff"; // fallback
  }

  const r = parseInt(bgColor.substr(1, 2), 16);
  const g = parseInt(bgColor.substr(3, 2), 16);
  const b = parseInt(bgColor.substr(5, 2), 16);

  // Make a darker shade (40% brightness)
  const darken = (channel) => Math.max(0, Math.floor(channel * 0.4));

  const darkR = darken(r);
  const darkG = darken(g);
  const darkB = darken(b);

  return `rgb(${darkR}, ${darkG}, ${darkB})`;
}



// Function to get color based on type
function getColorByType(type, dataType) {
  if (dataType === "Different") return "#cccccc";
  if (!type) return "#BDBDBD";

  const lowerType = type.toLowerCase();

  const colorMap = {
    cnv: "#ffa07a",       // Orange 
    mrna: "#8de6f6",      // Blue 
    protein: "#42ae75",   // Green 
    mutation: "#ff6347",  // Red 
    fusion: "#dda0dd",    // Purple
    methylation: "#fdd835",// Yellow
    molecular: "#cccccc"  // Gray
  };

  // Find the first matching key inside the string
  for (const key in colorMap) {
    if (lowerType.includes(key)) {
      return colorMap[key];
    }
  }

  return "#BDBDBD"; // fallback
}

function generateGenesAndEdges(genesData, dataType) {
  const genes = [];
  const edges = [];

  for (let i = 0; i < genesData?.nodes?.length; i++) {
    const node = genesData?.nodes[i]?.data;
    const color = getColorByType(node?.type, dataType);
    const gene = {
      data: {
        id: node?.id,
        label: node?.name,
        name: node?.name,
        shapeType: getShapeByType(node?.type, dataType),
        colorType: getColorByType(node?.type, dataType),
        fontColorType: getFontColorByBackground(color),
      },
    };
    genes.push(gene);
  }

  for (let i = 0; i < genesData?.edges?.length; i++) {
    const edge = {
      data: {
        source: genesData?.edges[i]?.data?.source,
        target: genesData?.edges[i]?.data?.target,
        rule_description: genesData?.edges[i]?.data?.rule_description || "",
      },
    };
    edges.push(edge);
  }

  return [...genes, ...edges];
}

export default generateGenesAndEdges;
